<template>
  <app-layout>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <h1>{{ $t('Solicitudes LOPD') }}</h1>
            </v-card-title>
            <v-card-text>
              <lopd-table
                entity="opendata-form"
                :level="1"
                search-input
                default-icon="mdi-document"
              ></lopd-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import LopdTable from '../components/LopdTable';
export default {
  components: {
    AppLayout,
    LopdTable,
  },
  data() {
    return {};
  },
};
</script>
